/**
 * Grooming package (tier) shapes. Mirrors
 * backend/src/modules/grooming-package/grooming-package.validators.ts.
 *
 * A package is a `VendorService` (module GROOMER) plus a 1:1 detail row —
 * tier label, an ordered included-items list, and an optional MRP for a
 * derived (never stored) discount %. Booking a package books its service_id;
 * there is no package-level payment or multi-session generation.
 */

export type GroomingTier = 'BASIC' | 'PREMIUM' | 'DELUXE';

export const GROOMING_TIER_OPTIONS: Array<{ value: GroomingTier; label: string }> = [
  { value: 'BASIC', label: 'Basic' },
  { value: 'PREMIUM', label: 'Premium' },
  { value: 'DELUXE', label: 'Deluxe' },
];

export const MAX_INCLUDED_ITEMS = 12;

export type GroomingPackage = {
  id: string;
  service_id: string;
  vendor_profile_id: string;
  tier: GroomingTier;
  name: string;
  description: string | null;
  price_inr: string;
  duration_minutes: number | null;
  mrp_inr: string | null;
  discount_pct: number | null;
  included_items: string[];
  is_active: boolean;
  created_at: string;
  updated_at: string;
};

export type CreateGroomingPackageInput = {
  tier: GroomingTier;
  name: string;
  description?: string;
  price_inr: number;
  duration_minutes: number;
  mrp_inr?: number;
  included_items: string[];
  is_active?: boolean;
};

export type UpdateGroomingPackageInput = Partial<CreateGroomingPackageInput> & {
  mrp_inr?: number | null;
};
